

























import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import MainTabbar from "../general/MainTabbar.vue";

import MembersOverview from "./MembersOverview.vue";
import MembersAll from "./MembersAll.vue";
import MembersPayments from "./MembersPayments.vue";

import SettingsJson from "../../shared/SettingsJson";
import SettingsNotificationsJson from "../../shared/SettingsNotificationsJson";
import UserJson from "../../shared/UserJson";
import ModulesJson, { checkModuleIsActivated } from "../../shared/ModulesJson";
import { checkPermission } from "../../shared/UserPermission";
import { UserPermissionType } from "../../shared/UserPermissionType";

export default Vue.extend({
  name: "Members",
  components: {
    MainTabbar,
    MembersOverview,
    MembersAll,
    MembersPayments,
  },
  props: {
    restClient: RestClient,
    loginUser: Object as PropType<UserJson>,
    loginId: Number,
    loginPermission: Number,
    settings: Object as PropType<SettingsJson>,
    settingsNotifications: Object as PropType<SettingsNotificationsJson>,
    appFrameClickedButton: Object,
  },
  data() {
    return {
      currentMainTabbarTab: "",
      checkModuleIsActivated: checkModuleIsActivated,
      checkPermission: checkPermission,
    };
  },
  created() {},
  methods: {
    changeMainTabbarTab: function (tab: string) {
      this.currentMainTabbarTab = tab;
    },
  },
  computed: {
    mainTabbarItems(): ModulesJson[] {
      let vue = this;

      return [
        {
          title: "Übersicht",
          linkedComponent: "MembersOverview",
          permissionRank: 2,
          userPermission: null,
          isDisabled: !vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleMembers),
          isDisplayed: vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleMembers),
        },
        {
          title: "Alle",
          linkedComponent: "MembersAll",
          permissionRank: 2,
          userPermission: null,
          isDisabled: !vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleMembers),
          isDisplayed: vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleMembers),
        },
        {
          title: "Zahlungen",
          linkedComponent: "MembersPayments",
          permissionRank: 2,
          userPermission: null,
          isDisabled: !vue.checkPermission(vue.loginUser, 2, UserPermissionType.modulePayments),
          isDisplayed: vue.checkPermission(vue.loginUser, 2, UserPermissionType.modulePayments),
        },
      ] as ModulesJson[];
    },
  },
});
